import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.div`
  background: white;
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  margin-bottom: 30px;
  overflow: hidden;
`;

const SectionHeader = styled.div`
  background: ${({ theme }) => theme.colors.light};
  padding: 15px 25px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.dark};

  svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const SectionContent = styled.div`
  padding: 25px;
  display: grid;
  gap: 20px;

  /* ✅ CORREÇÃO: Força duas colunas em telas maiores */
  grid-template-columns: repeat(2, 1fr);

  /* Em telas menores (tablets e celulares), volta para uma coluna */
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

const InfoSection = ({ title, icon, children }) => (
  <SectionWrapper>
    <SectionHeader>
      {icon} {title}
    </SectionHeader>
    <SectionContent>
      {children}
    </SectionContent>
  </SectionWrapper>
);

export default InfoSection;